import axios from 'axios';
import { novaDreamMapConfig } from 'config';
// ----------------------------------------------------------------------
//const axiosInstance = axios.create({ baseURL: novaDreamMapConfig.urlBase });
const axiosInstance = axios.create({
  baseURL: novaDreamMapConfig.urlAmplify,
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config: any) => {
  const token = localStorage.getItem('accessToken');
  const baseHeaders = {
    ...config.headers,
  };
  if (token) {
    return {
      ...config,
      headers: {
        ...baseHeaders,
        Authorization: `Bearer ${token}`,
      },
    };
  }

  return {
    ...config,
    headers: {
      ...baseHeaders,
    },
  };
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
